import SenderReceiverDataTypeListItem from '../components/SenderReceiverDataTypeListItem'

export default class DataSourceItem extends SenderReceiverDataTypeListItem {}
